<template>
  <q-dialog
    :visible="isVisible"
    :title="title"
    width="850px"
    :innerScroll="false"
    :offsetHeight="170"
    :contentLoading="contentLoading"
    @close="onCancel"
    @cancel="onCancel"
    @confirm="onConfirm"
  >
    <div class="step-wrap">
      <el-steps :active="activeStep" finish-status="finish">
        <el-step title="组件配置"></el-step>
        <el-step title="基础信息"></el-step>
      </el-steps>
    </div>
    <div class="drag-container" v-show="activeStep === 0">
      <div class="drag-left">
        <!-- <div style="font-weight: bold">背景图</div>
        <div class="upload-box">
          <el-upload
            class="prizeImg-uploader"
            action=""
            :show-file-list="false"
            :http-request='uploadImg'
            >
            <img v-if="configForm.backgroundImg" :src="configForm.backgroundImg" class="prizeImg">
            <i v-else class="el-icon-plus prizeImg-uploader-icon"></i>
          </el-upload>
        </div> -->
        <div style="font-weight: bold">组件列表</div>
        <ul @dragstart="dragStart" @dragend="dragEnd">
          <li
            v-for="(val, key, index) in componentList"
            draggable
            :data-com="key"
            :data-comid="val.comId"
            :key="index + 1">
              <span :class="val.icon"></span>
              <p>{{val.name}}</p>
          </li>
        </ul>
      </div>
      <div class="drag-middle">
        <div class="top-nav">
          <img :src="topBg">
          <span class="tit">活动首页</span>
        </div>
        <div
          class="view-content"
          :style="viewStyleObj"
          @drop="drop"
          @dragover="dragOver">
            <draggable v-model="viewList" draggable=".item">
              <template v-for="(item, index) in viewList">
                <div
                  :data-index="index"
                  :key="index"
                  class="item">
                  <!-- waiting -->
                  <template v-if="item.status && item.status == 2">
                    <div class="wait"> {{ item.comName | comNameEnum }} </div>
                  </template>
                  <template v-else>
                    <component :is="componentList[item.comName]['com']" :tmpType="creationMethod.tmpType"></component>
                  </template>
                  <i @click="deleteItem($event, index)" class="el-icon-error"></i>
                </div>
              </template>
            </draggable>
        </div>
      </div>
      <div class="drag-right"></div>
    </div>

    <div v-show="activeStep > 0" class="form-wrap">
      <el-form
        ref="basicForm"
        :model="basicForm"
        :rules="basicRules"
        :disabled="isView"
        label-width="85px">
        <el-form-item label="模板名称" prop="tmpName">
          <el-input v-model.trim="basicForm.tmpName" size="small" :maxlength="500"></el-input>
        </el-form-item>
        <el-form-item label="模板描述" prop="tmpDesc">
          <el-input v-model.trim="basicForm.tmpDesc" size="small" :maxlength="500"></el-input>
        </el-form-item>
        <el-form-item label="标签" prop="tmpTags">
          <el-input v-model.trim="basicForm.tmpTags" size="small" :maxlength="500" placeholder="多个标签用逗号分隔" @blur="handleTags"></el-input>
        </el-form-item>
        <el-form-item label="关联角色" prop="roleCode" size="small">
          <el-select v-model="basicForm.roleCode" multiple placeholder="请选择" style="width: 100%">
            <el-option
              v-for="item in roleOptions"
              :key="item.roleCode"
              :label="item.roleName"
              :value="item.roleCode">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
     
    </div>

    <template #footer>
      <template v-if="activeStep === 0">
        <el-button size="small" @click="onCancel">取消</el-button>
        <el-button type="primary" size="small" @click="nextStep">下一步</el-button>
      </template>
      <template v-else>
        <el-button size="small" @click="preStep">上一步</el-button>
        <el-button v-if="isView"  type="primary" size="small" @click="onCancel">关闭</el-button>
        <el-button v-else type="primary" size="small" @click="sumbit">确认</el-button>
      </template>
    </template>
  </q-dialog>
</template>

<script>
import Draggable from 'vuedraggable'
import { assignValue, debounce } from '@/utils'
import Images from './components/images'
import ImageVideo from './components/image-video'
import Attention from './components/attention'
import Store from './components/store'
import SignUp from './components/sign-up'
import Lottery from './components/lottery'
import Reserve from './components/reserve'
import Question from './components/question'
import Spike from './components/spike'
import ConnectPic from './components/connect-pic'
import GroupBuying from './components/group-buying'
import Drawlots from  './components/drawlots'
import styleTest from './components/style-test'
import countMoney from './components/count-money'
import coupon from './components/coupon.vue'

const mapHomeBackgroundImg = [
  'https://img3.quanyou.com.cn/joy/group1/M00/10/0D/rB4ChmJ530GAThsuAADDrxD5tQA440.png',
  'https://img3.quanyou.com.cn/joyNew/group1/M00/1D/1E/rB8LrmUx9JuAQDWuAA4vdldUFEM256.png',
  'https://img3.quanyou.com.cn/joyNew/group1/M00/22/C7/rB8LrWVldWOAFeMlABm54FI-e2c244.png',
  'https://img3.quanyou.com.cn/joyNew/group1/M00/1D/CE/rB8LrmU5v56Afqb4ABIQ6sZQDpQ047.png',
  'https://img3.quanyou.com.cn/joyNew/group1/M00/1E/56/rB8LrmU_BleAIENXAApiZAoTTeY706.png',
  'https://img3.quanyou.com.cn/joyNew/group1/M00/C3/F7/rB8Lrmlls2uAGYpGAAY0k6F1X40836.png'
]
export default {
  name: 'AddTemplate',
  components: {
    Draggable,
    ImageVideo,
    Attention,
    Store,
    SignUp,
    Images,
    Lottery,
    Reserve,
    Question,
    Spike,
    ConnectPic,
    GroupBuying,
    Drawlots,
    styleTest,
    countMoney,
    coupon
  },
  props: {
    // 重新对外暴露visible，控制显示隐藏
    visible: {
      type: Boolean,
      default: false
    },
    modifyData: Object,
    // 1:新增  2:修改  3:查看
    actionType: Number,
    creationMethod: Object
  },
  computed: {
    // 通过计算属性，对.sync进行转换，外部也可以直接使用visible.sync
    isVisible: {
      get () {
        return this.visible
      },
      set (val) {
        this.$emit('update:visible', val)
      }
    },
    title () {
      const titleMap = {
        1: '新增',
        2: '修改',
        3: '查看'
      }
      return titleMap[this.actionType]
    },
    isView () {
      return this.actionType == 3
    },
    viewStyleObj () {
      return {
        backgroundImage: `url(${mapHomeBackgroundImg[this.creationMethod.tmpType-1]})`,
        backgroundSize: '100% auto'
      }
    },
    isNewLotteryTmp () {
      return this.creationMethod.tmpType == 6
    }
  },
  data () {
    // 只能包含字母、数字、中文以及中英文逗号
    const tagsReg = /^([\d\w\u4e00-\u9fa5]+[,，]?)*$/
    const tagsValidator = (rule, value, callback) => {
      if (tagsReg.test(value)) {
        callback()
      } else {
        callback(new Error('标签只能包含字母、数字、中文以及中英文逗号'))
      }
    }
    return {
      contentLoading: false,
      configForm: {
        backgroundImg: ''
      },
      basicForm: {
        tmpId: '',
        tmpName: '',
        tmpDesc: '',
        tmpTags: '',
        roleCode: [],
        boolNewLottery: 'N',
      },
      basicRules: {
        tmpName: [
          { required: true, message: '模板名称不能为空', trigger: 'blur' }
        ],
        tmpDesc: [
          { required: true, message: '模板描述不能为空', trigger: 'blur' }
        ],
        tmpTags: [
          { validator: tagsValidator, trigger: 'blur' }
        ],
        roleCode: [
          { required: true, message: '关联角色不能为空', trigger: 'change' }
        ]
      },
      topBg: require('@/assets/images/topNavBlack.png'),
      // 按ID保存组件列表信息
      componentMap: {},
      // 组件列表
      componentList: {},
      // 已选择的组件列表
      viewList: [],
      // 正在拖拽的组件名称
      draggingComName: '',
      draggingComId: '',
      index: null, // 当前组件的索引
      isPush: false, // 是否已添加组件
      activeStep: 0,
      isLottery: false, // 是否是抽奖
      roleOptions: [],
      debounce: () => {}
    }
  },
  methods: {
    async init () {
      this.queryUserRole()
      await this.getComponentList()
      if (this.modifyData) {
        this.initModifyData()
      }
      this.debounce = debounce(this.onConfirm, 500)
    },
    queryUserRole() {
      this.$api.templateMgmt.queryUserRole()
       .then(res => {
         this.roleOptions = res.data
       })
    },
    getComponentList () {
      const params = {
        pageNum: 1,
        pageSize: 100,
        filterData: {}
      }
      return this.$api.templateMgmt.getComponentList(params)
        .then(({ data: { list } }) => {
          const componentList = {}
          this.componentMap = {}
          list.forEach(item => {
            this.componentMap[item.baseModuleId] = item
            switch (item.moduleType) {
              case 'sign-up':
                componentList.signUp = {
                  name: '报名',
                  icon: 'el-icon-phone-outline',
                  com: SignUp,
                  comId: item.baseModuleId,
                  type: 2
                }
                break
              case 'picture':
                componentList.images = {
                  name: '图片',
                  icon: 'el-icon-picture',
                  com: Images,
                  comId: item.baseModuleId,
                  type: 2
                }
                break
              case 'store':
                componentList.store = {
                  name: '门店',
                  icon: 'el-icon-s-home',
                  com: Store,
                  comId: item.baseModuleId,
                  type: 2
                }
                break
              case 'image-text-detail':
                componentList.imageVideo = {
                  name: '图文详情',
                  icon: 'el-icon-picture',
                  com: ImageVideo,
                  comId: item.baseModuleId,
                  type: 2
                }
                break
              case 'attention':
                componentList.attention = {
                  name: '注意事项',
                  icon: 'el-icon-warning',
                  com: Attention,
                  comId: item.baseModuleId,
                  type: 2
                }
                break
              case 'lottery':
                componentList.lottery = {
                  name: '抽奖',
                  icon: 'el-icon-present',
                  com: Lottery,
                  comId: item.baseModuleId,
                  type: 1
                }
                break;
              // case 'live-reserve':
              //   componentList.reserve = {
              //     name: '直播',
              //     icon: 'el-icon-video-camera',
              //     com: Reserve,
              //     comId: item.baseModuleId
              //   }
              //   break;
              case 'question':
                componentList.question = {
                  name: '问答',
                  icon: 'el-icon-edit',
                  com: Question,
                  comId: item.baseModuleId,
                  type: 1
                }
                break
              case 'spike':
                componentList.spike = {
                  name: '秒杀',
                  icon: 'el-icon-alarm-clock',
                  com: Spike,
                  comId: item.baseModuleId,
                  type: 1
                }
                break
              case 'connectPic':
                componentList.connectPic = {
                  name: '拼图',
                  icon: 'el-icon-menu',
                  com: ConnectPic,
                  comId: item.baseModuleId,
                  type: 1
                }
                break;
              case 'groupBuying':
                componentList.groupBuying = {
                  name: '拼团',
                  icon: 'el-icon-goods',
                  com: GroupBuying,
                  comId: item.baseModuleId,
                  type: 1
                }
                break;
              case 'drawLots':
                componentList.drawLots = {
                  name: '求签',
                  icon: 'el-icon-s-promotion',
                  com: Drawlots,
                  comId: item.baseModuleId,
                  type: 1
                }
                break;
              case 'style':
                componentList.style = {
                  name: '风格测试',
                  icon: 'el-icon-s-platform',
                  com: styleTest,
                  comId: item.baseModuleId,
                  type: 1
                }
                break;
              case 'countMoney':
                componentList.countMoney = {
                  name: '红包挑战赛',
                  icon: 'el-icon-trophy-1',
                  com: countMoney,
                  comId: item.baseModuleId,
                  type: 1
                }
                break;
              case 'coupon':
                // 创建方式为旧的时候添加优惠券组件
                if (this.creationMethod.creationMethod == 1) {
                    componentList.coupon = {
                    name: '优惠券',
                    icon: 'el-icon-s-ticket',
                    com: coupon,
                    comId: item.baseModuleId,
                    type: 1
                  }
                }
                break;
              default:
                break
            }
          })
          this.componentList = componentList
        })
        .catch(err => {
          console.log(err)
        })
    },
    nextStep () {
      if (!this.checkConfigValid()) {
        return false
      }
      this.basicForm.boolNewLottery = this.isNewLotteryTmp ? 'Y' : 'N'
      this.activeStep++
    },
    preStep () {
      this.activeStep--
    },
    handleTags () {
      this.basicForm.tmpTags = this.basicForm.tmpTags
        .replace(/\s/g, '')
        .replace(/[，|,]+/g, ',')
        .replace(/^[,]|[,]$/g, '')
    },
    initModifyData () {
      this.contentLoading = true
      this.$api.templateMgmt.getTemplateInfoById(this.modifyData.tmpId)
        .then(({ data }) => {
          assignValue(this.basicForm, data)
          this.viewList = []
          data.activityTmpModuleVOS.forEach(item => {
            let comName = ''
            switch (item.moduleType) {
              case 'sign-up':
                comName = 'signUp'
                break
              case 'picture':
                comName = 'images'
                break
              case 'store':
                comName = 'store'
                break
              case 'image-text-detail':
                comName = 'imageVideo'
                break
              case 'attention':
                comName = 'attention'
                break
              case 'lottery':
                comName = 'lottery'
                break
              case 'live-reserve':
                comName = 'reserve'
                break
              case 'question':
                comName = 'question'
                break
              case 'spike':
                comName = 'spike'
                break
              case 'connectPic':
                comName = 'connectPic';
                break;
              case 'groupBuying':
                comName = 'groupBuying';
                break;
              case 'drawLots':
                comName = 'drawLots';
                break;
              case 'style':
                comName = 'style';
                break;
              case 'countMoney':
                comName = 'countMoney';
                break;
              case 'coupon':
                comName = 'coupon';
                break;
              default:
                break
            }

            this.viewList.push({
              comId: item.baseModuleId,
              comName
            })
          })
        })
        .catch(err => {
          console.log(err)
        })
        .finally(_ => {
          this.contentLoading = false
        })
    },
    onCancel () {
      this.isVisible = false
    },
    checkConfigValid () {
      // 模板组件不能为空
      if (!this.viewList.length) {
        this.$message.error('请至少选择一个组件元素')
        return false
      }
      // 红包挑战赛组件只能单独创建
      const index =this.viewList.findIndex(item => item.comName === 'countMoney')
      if (this.viewList.length > 1 && index !==-1) {
        this.$message.error('红包挑战赛模板只能单独创建，不能和其他组件一起使用')
        return false
      }
      return true
    },
    sumbit () {
      this.debounce()
    },
    onConfirm () {
      // 模板组件不能为空
      if (!this.checkConfigValid()) {
        return false
      }
      this.$refs.basicForm.validate((valid) => {
        if (!valid) return

        const selectedComList = this.viewList.map((item, index) => {
          return {
            sortNo: index,
            tmpId: this.modifyData ? this.modifyData.tempId : '',
            moduleType: this.componentMap[item.comId] && this.componentMap[item.comId].moduleType || '',
            baseModuleId: item.comId
          }
        })
        const params = {
          ...this.basicForm,
          activityTmpModuleDTOS: selectedComList,
          ...this.creationMethod
        }

        this.contentLoading = true
        this.$api.templateMgmt
          .saveTemplate(params)
          .then(({ data }) => {
            const message = this.modifyData ? '修改模板成功' : '新增模板成功'
            this.$notify.success({
              title: '成功',
              message
            })
            this.isVisible = false
            this.$emit('success')
          })
          .finally(_ => {
            this.contentLoading = false
          })
      })
    },
    dragStart (e) {
      this.draggingComName = e.target.dataset.com
      this.draggingComId = e.target.dataset.comid
    },
    dragEnd () {
      if (this.isView) {
        return
      }
      // 新大转盘组件只能单独创建抽奖模版
      if (this.isNewLotteryTmp && this.draggingComName != 'lottery') return
       
      this.$delete(this.viewList[this.index], 'status')
      this.isPush = false
      this.draggingComName = ''
      this.draggingComId = ''
    },
    dragOver (e) {
      if (this.isView || !this.draggingComName) { // 内容拖拽
        return
      }
      // 新大转盘组件只能单独创建抽奖模版
      if (this.isNewLotteryTmp && this.draggingComName != 'lottery') return
      e.preventDefault()
      e.stopPropagation()

      const name = e.target.className !== 'view-content' ? 'item' : 'view-content'
      const defaultData = {
        comId: this.draggingComId,
        // 组件名称
        comName: this.draggingComName,
        // 默认状态
        status: 2
      }

      if (name == 'view-content') {
        if (!this.isPush) {
          this.index = this.viewList.length
          this.isPush = true
          this.viewList.push(defaultData)
        }
      } else if (name == 'item') {
        const target = e.target
        let [y, h, curIndex] = [e.offsetY, target.offsetHeight, target.dataset.index]
        const direction = y < (h / 2)

        if (!this.isPush) {
          // Push to Top or Bottom
          if (direction) {
            if (curIndex == 0) {
              this.viewList.unshift(defaultData)
            } else {
              this.viewList.splice(curIndex, 0, defaultData)
            }
          } else {
            curIndex = +curIndex + 1
            this.viewList.splice(curIndex, 0, defaultData)
          }
        } else {
          // Moving
          if (direction) {
            var i = curIndex == 0 ? 0 : curIndex - 1
            var result = this.viewList[i].status == 2
          } else {
            var i = +curIndex + 1
            var result = this.viewList.length > i && this.viewList[i].status == 2
          }

          if (result) return

          const temp = this.viewList.splice(this.index, 1)
          this.viewList.splice(curIndex, 0, temp[0])
        }
        this.index = curIndex
        this.isPush = true
      }
    },
    drop (e) {
      if (!this.draggingComName) { // 内容拖拽
        return
      }
      e.preventDefault()
      e.stopPropagation()
      this.dragEnd()
    },
    deleteItem (e, index) {
      if (this.isView) {
        return
      }
      e.preventDefault()
      e.stopPropagation()
      this.viewList.splice(index, 1)
    },
    uploadImg (file) {
      const isLt2M = file.file.size / 1024 / 1024 < 3
      const a = /\.(jpg|jepg|png)$/
      const isType = a.test(file.file.name)
      if (!isLt2M) {
        this.$message.error('上传图片大小不能超过 3MB!')
        return
      }
      if (!isType) {
        this.$message.error('请上传jpg/png图片!')
        return
      }

      // TODO
      this.configForm.backgroundImg = 'https://cube.elemecdn.com/6/94/4d3ea53c084bad6931a56d5158a48jpeg.jpeg'
    }
  },
  filters: {
    comNameEnum (val) {
      const comMap = {
        signUp: '报名',
        images: '图片',
        store: '门店',
        attention: '注意事项'
      }
      return comMap[val] || ''
    }
  },
  created () {
    this.init()
  }
}
</script>

<style lang="stylus" scoped>
$viewHeight=500px
$bgGradientColor = linear-gradient(#FF7843, #FF5451)

.form-input
  width 200px
.input-number
  >>> .el-input__inner
    text-align left

.step-wrap
    display: flex
    justify-content: center
    >>> .el-steps
      width 60%
      .el-step__title
        font-size 14px

.form-wrap
  padding 0 15px
  min-height: 576px

.upload-box
  padding 5px 0
  text-align: center

.prizeImg-uploader
  >>>.el-upload
    border: 1px dashed  #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  &:hover
    border-color: #0bb78e;
  .prizeImg-uploader-icon
    font-size: 28px;
    color: #8c939d;
    width: 100px;
    height: 100px;
    line-height: 100px;
    text-align: center;
  .prizeImg
    width: 100px;
    height: 100px;
    display: block;

.drag-container
  display: flex;
  align-items: center;
  justify-content: space-between;
  // padding: 10px 0;
  // background: #f7f8f9;
  position: relative;
  .drag-left
    width 300px
    align-self flex-start
    ul
      margin: 0;
      padding: 0;
      height: 400px
      li
        width: 80px;
        height: 80px;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        cursor: default;
        list-style: none;
        font-size: 14px;
        color: #666;
        float: left;
        margin: 0 10px;
        border-radius: 6px;
        transition: all .3s;
        cursor: pointer;
        &:hover
          background: #efefef;
        span
          display: block;
          font-size: 40px;
          margin-bottom: 8px;
          color: #999;
        p
          display: block;
          margin: 0;
          font-size: 12px;
  .drag-middle {
    width: auto;
    max-width: 350px;
    position: relative;
    .top-nav {
      position: absolute;
      top: 0;
      background: #fff;
      z-index: 999;
      & * {
        pointer-events: none;
      }
      .tit{
        position: absolute;
        left: 50%;
        bottom: 10px;
        transform: translateX(-50%);
      }
      img {
        max-width: 100%;
        image-rendering: -moz-crisp-edges;
        image-rendering: -o-crisp-edges;
        image-rendering: -webkit-optimize-contrast;
        image-rendering: crisp-edges;
        -ms-interpolation-mode: nearest-neighbor;
      }
    }
    .view-content{
      width: 350px;
      height: $viewHeight
      background: $bgGradientColor;
      overflow-y: auto;
      overflow-x: hidden;
      padding-top: 65px;
      padding-bottom: 10px;
      box-shadow: 0 2px 6px #ccc;
      &::-webkit-scrollbar{
        width: 6px;
      }
      &::-webkit-scrollbar-thumb{
        background: #dbdbdb;
      }
      &::-webkit-scrollbar-track{
        background: #f6f6f6;
      }

      .item{
        transition: all .3s;
        // background: #fff;
        &:hover{
          transform: scale(0.95);
          border-radius: 10px;
          // box-shadow: 0 0 10px #afafaf;
          .el-icon-error{
            display: block;
          }
        }
        div{
          pointer-events: none;
        }
        .wait{
          background: #deedff;
          height: 35px;
          text-align: center;
          line-height: 35px;
          font-size: 12px;
          color: #666;
        }
        .el-icon-error {
          position: absolute;
          right: -10px;
          top: -6px;
          color: #fff;
          font-size: 25px;
          cursor: pointer;
          display: none;
          z-index: 9999;
        }
      }
    }
  }
</style>
